import { Routes, Route, Navigate } from "react-router-dom";
import CalculadoraAumento from "./pages/CalculadoraAumento";
import CalculadoraCuotas from "./pages/CalculadoraCuotas";

function App() {
  return (
    <Routes>
      <Route
        index
        path="/calculadora-aumento"
        element={<CalculadoraAumento />}
      />
      <Route path="/calculadora-cuota" element={<CalculadoraCuotas />} />
      <Route
        path="*"
        element={<Navigate replace to="/calculadora-aumento" />}
      />
    </Routes>
  );
}

export default App;
